import { Injectable } from '@angular/core';
import moment from 'moment';
import { LoadingController, AlertController, Platform } from 'ionic-angular';
import { Http, Headers } from '@angular/http';
import { TranslateService } from '@ngx-translate/core';
import { Storage } from '@ionic/storage';
import 'rxjs/add/operator/map';
import { AppVersion } from '@ionic-native/app-version';
import numeral from 'numeral';
import { CustomizerProvider } from './customizer/customizer';

@Injectable()
export class provider {
  loading: any;
  data: any;
  restaurant: any;
  token: any;
  idTavolo: any;
  cart = [];
  message: any;
  resp: any;
  menu_tms: any;
  tot: any;
  client_id: any;
  form;
  selectedLocale = false;
  sfogliamenu = false;
  temporaryCustomer: object;
  firstOrder = false;

  constructor(
    public http: Http,
    public loadingCtrl: LoadingController,
    public storage: Storage,
    public alertCtrl: AlertController,
    public appVersion: AppVersion,
    public translateService: TranslateService,
    public platform: Platform,
    public customizer: CustomizerProvider
  ) {


    this.storage.get('client_id').then((id) => {
      if (id) {
        this.client_id = id;
      }
    });

    this.loading = this.loadingCtrl.create({
      content: '<ion-spinner></ion-spinner>'
    });

    if (!this.platform.is('core')) {
      this.platform.ready().then(() => {
        const msg = {
          ATTENZIONE: 'Attenzione !',
          UPDATE_AVAILABLE: 'C\'è un aggiornamento disponibile',
          SERVER_UNAVAILABLE: 'Errore di collegamento al server'
        }
        this.appVersion.getPackageName().then(appBundleId => {
          this.appVersion.getVersionNumber().then(appVersionCode => {
            this.http.get(`https://api.tapmenu.it/api-url/check-update/${appBundleId}/${appVersionCode}`).map(res => res.json()).subscribe(data => {
              if (data.update) {
                this.alertCtrl.create({
                  enableBackdropDismiss: false,
                  title: msg.ATTENZIONE,
                  subTitle: msg.UPDATE_AVAILABLE,
                  buttons: [{
                    text: 'Ok',
                    role: null,
                    handler: () => {
                      if (this.platform.is('mobile')) {
                        this.appVersion.getPackageName().then(pack => {
                          this.getStoreUrl(pack).then(url => {
                            // open store url
                            window.open(url, "_system");
                          })
                        }).catch(function (err) {
                          console.log("PackageName" + err);
                        });
                      } else {
                        // we are on fixed platform
                        location.reload();
                      }
                      return false
                    }
                  }]
                });
              }
            })
          }).catch(function (err) {
            console.log("VersionNumber" + err);
          });
        }).catch(function (err) {
          console.log("PackageName" + err);
        });
      });
    }

  }

  private buildAuthHeaders(content_type: string = null) {
    let headers = new Headers();
    if (this.token != null)
      headers.append('Authorization', 'Bearer ' + this.token);
    if (this.client_id)
      headers.append('client_id', this.client_id);
    if (content_type != null)
      headers.append('Content-Type', content_type);
    return headers;
  }

  getMenuExpired() {
    return moment.duration(moment().diff(this.menu_tms)).asHours() >= 1;
  }

  getUrl() {
    return this.customizer.getApiURL().toString();
  }

  getTable(url) {
    if (this.data) {
      return Promise.resolve(this.data);
    }
    return new Promise(resolve => {
      this.http.get(url).subscribe(data => {
        resolve(data);
      }, error => {
        resolve(error)
      });
    });
  }

  setTable(table) {
    this.token = table;
  }

  setSfogliamenu() {
    this.sfogliamenu = true
  }

  isSfogliamenu() {
    return this.sfogliamenu;
  }

  /*
   * getTemporaryCustomer 
   * restituisce l'eventuale cliente "volante" recuperato dalla
   * web-app
   */
  getTemporaryCustomer() {
    return this.temporaryCustomer;
  }								  

  /*
   * setTemporaryCustomer(temporaryCustomer)
   * imposta il cliente "volante" recuperato dalla
   * web-app
   */
  setTemporaryCustomer(temporaryCustomer) {
    this.temporaryCustomer = temporaryCustomer;
  }								  

  getToken() {
    return this.token
  }

  //get menu from server
  getData() {
    let headers = this.buildAuthHeaders();

    if (this.data) {
      // use cached results
      return Promise.resolve(this.data);
    }

    return new Promise(resolve => {
      this.http.get(this.customizer.getApiURL() + '/menu/get-active', { "headers": headers }).map(res => res.json()).subscribe(data => {
        this.idTavolo = data.tavolo._id;
        this.menu_tms = moment();
        this.data = data;
        this.deleteCart();
        resolve(this.data);
      },
        err => {
          resolve(err);
        },
        () => {
          this.loading.dismiss();
        });
    });
  }

  sbloccaTavolo(tavolo, cod) {
    let headers = this.buildAuthHeaders();
    return this.http.get(this.customizer.getApiURL() + "/tavoli/verifica-codice/" + tavolo + "/" + cod, { "headers": headers });
  }

  setCard(phone,cod,id) {
    return this.http.post(this.customizer.getApiURL() + "/cards/match/", { phone: phone, otc: cod, ownerId: id });
  }

  getCardBalance(hash) {
    let headers = this.buildAuthHeaders();
    return this.http.post(this.customizer.getApiURL() + '/cards/balance/', { hash: hash }, { "headers": headers })
  }

  cardsBackup(phone,id) {
    return this.http.post(this.customizer.getApiURL() + '/cards/backup/', { telephone: phone, ownerId: id });
  }

  getMenu() {
    return this.data;
  }

  //calculate the total of the order
  getTotal(ordine, nRiga) {
    let calcolo = eval(this.data.calcolo);
    return calcolo(ordine, numeral, nRiga);
  }

  setTotal(tot) {
    this.tot = tot;
  }

  renderDescr(obj) {
    return ((obj.descrizione.find(descr => descr.lingua == this.translateService.currentLang.toUpperCase()) || { contenuto: false }).contenuto ||
      (obj.descrizione.find(descr => descr.main) ||
        { contenuto: 'NO DESCRIZIONE' }).contenuto)
  }

  renderDescrEstesa(obj) {
    return ((obj.descrizioneEstesa.find(descr => descr.lingua == this.translateService.currentLang.toUpperCase()) || { contenuto: false }).contenuto ||
      (obj.descrizioneEstesa.find(descr => descr.main) ||
        { contenuto: 'NO DESCRIZIONE' }).contenuto).replace(/\n/g, '<br \/>')
  }

  transformCart(cart) {
    let riga, variante, descrizione, righe = [], varianti = [];
    for (let i = 0; i < cart.length; i++) {
      for (let j = 0; j < cart[i].varIngr.length; j++) {
        if (this.cart[i].varIngr[j].quantita != 0) {
          for (let k = 0; k < cart[i].varIngr[j].descrizione.length; k++) {
            if (this.cart[i].varIngr[j].descrizione[k].main) {
              descrizione = cart[i].varIngr[j].descrizione[k].contenuto;
            }
          }
          variante = {
            _id: cart[i].varIngr[j]._id,
            ctvlx: cart[i].varIngr[j].ctvlx,
            prezzo: cart[i].varIngr[j].prezzo,
            quant: cart[i].varIngr[j].quantita,
            descrizione: descrizione,
            extraProps: cart[i].varIngr[j].extraProps
          }
          varianti.push(variante);
        }
      }
      for (let k = 0; k < cart[i].prodotto.content.descrizione.length; k++) {
        if (cart[i].prodotto.content.descrizione[k].main) {
          descrizione = cart[i].prodotto.content.descrizione[k].contenuto;
        }
      }
      riga = {
        quant: cart[i].quantita,
        _id: cart[i].prodotto._id,
        updatedAt: cart[i].prodotto.updatedAt,
        prod: {
          _id: cart[i].prodotto.content._id,
          ctvlx: cart[i].prodotto.content.ctvlx,
          prezzo: cart[i].prodotto.content.prezzo,
          varIngr: varianti,
          updatedAt: cart[i].prodotto.content.updatedAt,
          descrizione: descrizione
        }
      }
      righe.push(riga);
      varianti = [];
    }
    this.tot = this.getTotal(righe, null);
  }

  //add item to the cart
  addToCart(item) {
    this.cart.push(item);
    this.transformCart(this.cart);
  }

  //get cart
  getCart() {
    return this.cart;
  }

  //get totale
  showTotal() {
    return this.tot;
  }

  editItemCart(prod) {
    for (let i = 0; i < this.cart.length; i++) {
      if (this.cart[i].id == prod.id) {
        this.cart[i] = prod;
      }
    }
  }

  //delete cart
  deleteCart() {
    this.cart.length = 0;
    this.tot = 0;
  }

  //delete item in cart
  deleteItemCart(id) {
    let n, value;
    value = this.getCart();
    for (let i = 0; i < value.length; i++) {
      if (value[i].id == id) {
        n = i;
      }
    }
    value.splice(n, 1);
    this.cart = value;
    this.transformCart(value);
  }

  clearApp() {
    this.token = null;
    this.data = null;
    this.deleteCart();
  }

  postOrdini(hash, how, when, righeOrdine, totOrdine, customer, takeaway, version, appVersion) {
    let fd = new FormData();
    let headers = this.buildAuthHeaders();
    fd.append('data', JSON.stringify({
      righe: righeOrdine,
      hash: hash,
      paymentType: { how: how, when: when },
      tavolo: this.data.tavolo._id,
      totale: totOrdine,
      deliveryCustomer: customer == null ? customer : customer._id,
      note: customer == null ? null : takeaway.note,
      deliveryAddress: customer == null ? null : takeaway.address,
      deliveryMode: customer == null ? null : takeaway.mode,
      deliverySchedule: customer == null ? null : takeaway.schedule,
      deliveryCost: customer == null ? null : takeaway.deliveryCost,
      deliveryDiscount: customer == null ? null : takeaway.deliveryDiscount,
      deliveryPlace: customer == null ? null : takeaway.place,
      fcmID: customer == null ? customer : customer.fcmID,
      version: version,
      appVersion: appVersion
    }));

    return this.http.post(this.customizer.getApiURL() + '/ordini', fd, { headers: headers });
  }

  getOrdiniCheck(ordineID) {
    let headers = this.buildAuthHeaders();
    return this.http.get(this.customizer.getApiURL() + '/ordini/check/' + ordineID, { "headers": headers });
  }

  phoneCall(form) {
    this.form = form;
    let headers = this.buildAuthHeaders('application/json');
    let fd = JSON.stringify({ number: form.telephone, firstName: form.firstName, lastName: form.lastName });
    return this.http.post(this.customizer.getUserDatabaseURL() + '/v2/phoneCall', fd, { "headers": headers });
  }

  phoneSMS(form) {
    this.form = form;
    let headers = this.buildAuthHeaders('application/json');
    let fd = JSON.stringify({ number: form.telephone, firstName: form.firstName, lastName: form.lastName });
    return this.http.post(this.customizer.getUserDatabaseURL2() + '/sms', fd, { "headers": headers });
  }

  register(code) {
    let headers = this.buildAuthHeaders('application/json');
    this.form.code = code;
    let fd = JSON.stringify(this.form);
    return this.http.post(this.customizer.getUserDatabaseURL().toString() + "/v2/post", fd, { headers: headers });
  }

  login(form) {
    let headers = this.buildAuthHeaders('application/json');
    let fd = JSON.stringify(form);
    return this.http.post(this.customizer.getUserDatabaseURL() + '/login', fd, { headers: headers });
  }

  edit(form) {
    let headers = this.buildAuthHeaders('application/json');
    let fd = JSON.stringify(form);
    return this.http.put(this.customizer.getUserDatabaseURL() + '/' + form.id, fd, { headers: headers });
  }

  delete(id) {
    let headers = this.buildAuthHeaders('application/json');
    return this.http.delete(this.customizer.getUserDatabaseURL() + '/' + id, { headers: headers });
  }

  getCustomer(id) {
    let headers = this.buildAuthHeaders('application/json');
    return this.http.get(this.customizer.getUserDatabaseURL() + '/' + id, { headers: headers });
  }

  getCities() {
    this.http.get(this.customizer.getApiURL() + "/cities/it").subscribe(result => {
      sessionStorage.setItem('comuni', (<any>result)._body);
    }, err => {
      console.log(err);
    });
  }

  getShops(code) {
    let headers = this.buildAuthHeaders('application/json');
    return this.http.get(this.customizer.getApiURL() + '/users/city-restaurants/' + code, { headers: headers });
  }

  getJWTAsporto(id) {
    let headers = this.buildAuthHeaders('application/json');
    return this.http.get(this.customizer.getApiURL() + '/customers/generate-order-jwt/' + id, { headers: headers });
  }


  getSlots(from: String = undefined) {
    let headers = this.buildAuthHeaders('application/json');
    return this.http.get(this.customizer.getApiURL() + (from != undefined ? '/orders/slots/' + from : '/orders/slots'), { "headers": headers });
  }

  updateFCMID(id, fcmID) {
    let headers = this.buildAuthHeaders('application/json');
    return this.http.patch(this.customizer.getUserDatabaseURL() + '/fcm-id/' + id, JSON.stringify({ fcmID: fcmID }), { headers: headers }).toPromise();
  }

  getNearCountry(latitude, longitude) {
    let headers = this.buildAuthHeaders('application/json');
    return this.http.get(this.customizer.getApiURL() + '/cities/near/' + latitude + '/' + longitude, { "headers": headers });
  }

  verifyEmail(email) {
    let headers = this.buildAuthHeaders('application/json');
    return this.http.get(this.customizer.getApiURL() + '/customers/check-email/' + email, { "headers": headers });
  }

  getPrivacy() {
    // let headers = this.buildAuthHeaders('application/json');
    return this.http.get('https://www.iubenda.com/api/privacy-policy/51897710/no-markup');
  }

  changePassword(id, customer) {
    let headers = this.buildAuthHeaders('application/json');
    return this.http.patch(this.customizer.getUserDatabaseURL() + '/password/' + id, JSON.stringify({ password: customer.password, confirmPassword: customer.confirmPassword }), { "headers": headers });
  }

  recoverPassword(email) {
    let headers = this.buildAuthHeaders('application/json');
    return this.http.get(this.customizer.getUserDatabaseURL() + '/recover-email/' + email, { "headers": headers });
  }

  getStoreUrl(appBundleId: String): Promise<string> {
    let result = new Promise<string>((resolve, reject) => {
      if (this.platform.is('android'))
        resolve(`https://play.google.com/store/apps/details?id=${appBundleId}`);
      else {
        // fetch trackId from Apple Store
        this.http.get(`https://itunes.apple.com/lookup?bundleId=${appBundleId}`).map(res => res.json()).subscribe(data => {
          if (data.resultCount > 0) {
            const appId = data.results[0].trackViewUrl;
            resolve(appId);
          }
        });
      }
    });
    return result;
  }

  //! isShopClosed checks if a shop is closed in a day
  isShopClosed(shopWorkingHours: Array<any>, dateToCheck: Date = undefined): Boolean {
    const dayMap = { Mon: 'LU', Tue: 'MA', Wed: 'ME', Thu: 'GI', Fri: 'VE', Sat: 'SA', Sun: 'DO' }
    const workingDate = (dateToCheck ? moment(dateToCheck) : moment());
    const currentTime = workingDate.format('HH:mm');
    const weekDay = dayMap[workingDate.format('ddd')];
    const openingTime = shopWorkingHours[weekDay];
    // check if we are in correct opening time
    return ((openingTime.length == 0) ||
      (openingTime[openingTime.length - 1].alle <= currentTime));
  }

  getSelectedLocale() : boolean {
    return this.selectedLocale;
  }

  setSelectedLocale(locale : boolean) {
    this.selectedLocale = locale;
  }

  makeCreditCardPayment(formData, paymentToken) {
    const headers = new Headers();
    headers.append('paymentToken', paymentToken);
    headers.append('Content-Type', 'application/json');

    return this.http.post(`${this.data.settings.sellaPaymentUrl}/v1/payment/submit`, formData, {'headers': headers });
  }

  isFirstOrder(): boolean {
    return this.firstOrder;
  }

  setFirstOrder(first: boolean) {
    this.firstOrder = first;
  }

  getTotalFromServer(obj) {
    let headers = this.buildAuthHeaders();
    return this.http.post(this.customizer.getApiURL() + '/ordini/generateTotal', obj, { "headers": headers })
  }
}



// WEBPACK FOOTER //
// ./src/providers/provider.ts